module.exports = __webpack_public_path__ + "images/index/05.807d6f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/Quanta/05.jpg
// module id = SbCm
// module chunks = 21